import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [_c("perfil", { attrs: { usuario: _vm.usuario } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }